import { MdClose } from "@teamworksdev/icons";
import { IconButton, TextField, TextFieldAddonLeft, TextFieldElementRight, TextFieldGroup } from "@teamworksdev/react";
import { ColorPickerV2 } from "./ColorPickerV2";

/**
 * Ensure the color is:
 * - made up of only valid hex characters
 * - has a max length of 6
 * - is uppercase
 * - starts with a `#` unless empty
 */
const sanitizeHexColor = (color: string) => {
  const sanitized = color
    .replaceAll(/[^A-Fa-f0-9]/g, "")
    .slice(0, 6)
    .toUpperCase();

  return sanitized ? `#${sanitized}` : "";
};

type ColorPickerInputProps = {
  value?: string;
  onChange?: (value: string) => void;
};

export const ColorPickerInput = ({ value = "", onChange }: ColorPickerInputProps) => (
  <TextFieldGroup className="overflow-visible">
    <TextFieldAddonLeft>
      <ColorPickerV2 value={value} onChange={(newColor) => onChange?.(sanitizeHexColor(newColor))} />
    </TextFieldAddonLeft>
    <TextField
      value={value}
      onChange={(e) => onChange?.(sanitizeHexColor(e.target.value))}
      placeholder="Select color"
      className="text-sm placeholder:text-xs"
    />
    {!!value && (
      <TextFieldElementRight>
        <IconButton
          aria-label="Clear"
          variant="ghost"
          size="sm"
          className="rounded-full p-0 w-6 h-6"
          icon={<MdClose />}
          onClick={() => onChange?.("")}
        />
      </TextFieldElementRight>
    )}
  </TextFieldGroup>
);

ColorPickerInput.displayName = "ColorPickerInput";
